import { Entity } from 'src/app/core/utils/entity';

export abstract class UpdateClaimStatusEntity extends Entity {
  constructor(
    public claimId: string,
    public status: string,
    public reasonForRejection?: string,
    public typeAdmimited?: string,
    public rejectionFile?: string[]
  ) {
    super();
  }
}
